import { z } from 'zod';

export const updateSchema = z.object({
    isEnabled: z.array(z.string()).default([]),
    createdUtc: z.string().optional(),
    updatedUtc: z.string().optional(),
});
